'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const find = require('lodash.find');

class TourStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._tour = {
            [TourStore.type.TRADE_TOUR]: {
                isTourOpen: false,
                currentStep: 1,
                totalSteps: 6
            },
            [TourStore.type.NET_PRICE_TOUR]: {
                isTourOpen: false,
                currentStep: 1,
                totalSteps: 1
            },
            [TourStore.type.REQUEST_ITEM_HOLD_TOUR]: {
                isTourOpen: false,
                currentStep: 1,
                totalSteps: 1
            }
        };
    }

    _onStepIncrease(type) {
        const tour = this._tour[type];
        if (tour) {
            tour.currentStep += 1;
            this.emitChange();
        }
    }

    _onTourOpen(type) {
        const tour = this._tour[type];
        if (tour) {
            tour.isTourOpen = true;
            this.emitChange();
        }
    }

    _onTourClose(type) {
        const tour = this._tour[type];
        if (tour) {
            tour.isTourOpen = false;
            tour.currentStep = 1;
            this.emitChange();
        }
    }

    isTourLoaded(type) {
        const tour = this._tour[type];
        return tour && tour.isLoaded;
    }

    isTourOpen(type) {
        const tour = this._tour[type];
        return tour && tour.isTourOpen;
    }

    isAnyTourOpen() {
        const tour = find(this._tour, {isTourOpen: true});
        return !!tour;
    }

    getCurrentStep(type) {
        const tour = this._tour[type];
        return tour && tour.currentStep;
    }

    getTotalSteps(type) {
        const tour = this._tour[type];
        return tour && tour.totalSteps;
    }

};

TourStore.storeName = 'TourStore';

TourStore.handlers = {
    'tour:step:increase': '_onStepIncrease',
    'tour:open': '_onTourOpen',
    'tour:close': '_onTourClose'
};

TourStore.type = {
    TRADE_TOUR: 'tradeTour',
    NET_PRICE_TOUR: 'netPriceTour',
    REQUEST_ITEM_HOLD_TOUR: 'requestItemHoldTour'
};

module.exports = TourStore;



// WEBPACK FOOTER //
// ./assets/js/components/Tour/TourStore.es.js